/**
 * Registra el SW propio de UDV (public/sw.js) solo en produccion.
 * @param {(registration: ServiceWorkerRegistration) => void} [onUpdateReady]
 */

export function registerUdvServiceWorker(onUpdateReady) {
  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production') {
    return
  }
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return
  }

  let refreshing = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return
    refreshing = true
    window.location.reload()
  })

  window.addEventListener('load', () => {
    const publicUrl = typeof process !== 'undefined' && process.env ? process.env.PUBLIC_URL || '' : ''
    const swUrl = `${publicUrl}/sw.js`

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        if (registration.waiting && navigator.serviceWorker.controller) {
          if (onUpdateReady) onUpdateReady(registration)
        }

        registration.onupdatefound = () => {
          const worker = registration.installing
          if (!worker) return
          worker.onstatechange = () => {
            if (worker.state === 'installed' && navigator.serviceWorker.controller) {
              if (onUpdateReady) onUpdateReady(registration)
            }
          }
        }
      })
      .catch((err) => {
        console.error('[UDV-SW] Registro fallido:', err)
      })
  })
}

/** Pide al SW en espera que active la nueva version (tras tap del usuario). */
export function applyServiceWorkerUpdate(registration) {
  if (!registration) return false
  const waiting = registration.waiting
  if (waiting) {
    waiting.postMessage({ type: 'SKIP_WAITING' })
    return true
  }
  return false
}
